import React from 'react';
import { Box } from '@wds/box';
import { Typography } from '@wds/typography';
import { Switch } from '../../../../sma.common/components/smapply-ui/Switch';

import PropTypes from 'prop-types';

import STRINGS from '../../../constants';
import CardTemplate from '../../../../sma.common/components/react/components/CardTemplate';

const tabStrings = STRINGS.accountSettingsPage.notificationSettingsTab;

const NotificationSettingsTab = (props) => {
	const {
		settings,
		notifications,
		handleChangeNotification,
		handleChangeCheckbox
	} = props;

	return (
		<>
			<CardTemplate
				cardTitle={tabStrings.title}
				id='notification-settings'
			>
				<Box px={2}>
					{notifications?.applicant && (
						<Box py={4} style={{ borderBottom: '1px solid #e0e0e0' }}>
							<Typography
								variant='cardTitle'
								weight='medium'
							>
								{STRINGS.applicantNotificationsLabel}
							</Typography>
							{Object.entries(notifications.applicant).map(([key]) => (
								<Box py={2} key={key} display='flex' justifyContent='space-between'>
									<Typography weight='medium'>
										{tabStrings[key]}
									</Typography>
									<Switch
										checked={settings[key]}
										onChange={handleChangeNotification(key)}
										id={key}
										disabled={settings && !settings.email_subscribed}
									/>
								</Box>
							))}
						</Box>
					)}
					{notifications?.reviewer && (
						<Box py={4} style={{ borderBottom: '1px solid #e0e0e0' }}>
							<Typography
								variant='cardTitle'
								weight='medium'
							>
								{STRINGS.reviewerNotificationsLabel}
							</Typography>
							{Object.entries(notifications.reviewer).map(([key]) => (
								<Box py={2} key={key} display='flex' justifyContent='space-between'>
									<Typography weight='medium'>
										{tabStrings[key]}
									</Typography>
									<Switch
										checked={settings[key]}
										onChange={handleChangeNotification(key)}
										id={key}
										disabled={settings && !settings.email_subscribed}
									/>
								</Box>
							))}
						</Box>
					)}
					{notifications?.recommender && (
						<Box py={4} style={{ borderBottom: '1px solid #e0e0e0' }}>
							<Typography
								variant='cardTitle'
								weight='medium'
							>
								{STRINGS.recommenderNotificationsLabel}
							</Typography>
							{
								Object.entries(notifications.recommender).map(([key]) => (
									<Box py={2} key={key} display='flex' justifyContent='space-between'>
										<Typography weight='medium'>
											{tabStrings[key]}
										</Typography>
										<Switch
											checked={settings[key]}
											onChange={handleChangeNotification(key)}
											id={key}
											disabled={settings && !settings.email_subscribed}
										/>
									</Box>
								))
							}
						</Box>
					)}
					<Box py={4}>
						<Typography
							variant='cardTitle'
							weight='medium'
						>
							{STRINGS.generalNotifications}
						</Typography>
						<Box
							py={2}
							display='flex'
							justifyContent='space-between'
							alignContent='center'
						>
							<Typography weight='medium'>
								{tabStrings.notify_direct_messages}
							</Typography>
							<Switch
								checked={settings.notify_direct_messages}
								onChange={handleChangeNotification('notify_direct_messages')}
								id='notify_direct_messages'
								disabled={settings && !settings.email_subscribed}
							/>
						</Box>
						<Box
							py={2}
							display='flex'
							justifyContent='space-between'
							alignContent='center'
						>
							<Typography weight='medium'>
								{tabStrings.email_subscribed}
							</Typography>
							<Switch
								checked={!settings.email_subscribed}
								onChange={handleChangeCheckbox('email_subscribed')}
								id='unsubsrcibe_all'
							/>
						</Box>
					</Box>
				</Box>
			</CardTemplate>
		</>
	)
};

NotificationSettingsTab.propTypes = {
	settings: PropTypes.object.isRequired,
	handleChangeNotification: PropTypes.func.isRequired,
	handleChangeCheckbox: PropTypes.func.isRequired,
	notifications: PropTypes.object.isRequired
}

export default NotificationSettingsTab;